<header>
  <h2 mat-dialog-title>
    {{ title }}
  </h2>
  <a class="close" (click)="close(false)">
    <mat-icon>close</mat-icon>
  </a>
</header>
<mat-dialog-content>
  <p>
    {{ text }}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close type="button" mat-button>Luk</button>
</mat-dialog-actions>
